module.exports = __webpack_public_path__ + "static/img/brick-well-2026.1b4e28b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/brick-well-2026.webp
// module id = WLiC
// module chunks = 0